module.exports = __webpack_public_path__ + "static/img/blade-runners_256.39c77ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blade-runners_256.png
// module id = IW9o
// module chunks = 0